import initColors from "./colors";
import initExterior from "./exterior";
import initInterior from "./interior";
import initPopup from "./popup";
import initSwitcher from "./switcher";

document.addEventListener("DOMContentLoaded", () => {
  initSwitcher();
  initPopup();
  initExterior();
  initColors();
  initInterior();
});
